import { __awaiter } from "tslib";
import { useThrowingAsync } from '../../hooks';
export default function useAsyncInitialValues(initialValuesOrFunction, modalVisible) {
    const isFunction = typeof initialValuesOrFunction === 'function';
    const { loading, value } = useThrowingAsync(() => __awaiter(this, void 0, void 0, function* () {
        if (isFunction && modalVisible) {
            return initialValuesOrFunction();
        }
    }), [initialValuesOrFunction, isFunction, modalVisible]);
    if (isFunction)
        return { loading, value };
    // just a plain initialvalues object
    return { loading: false, value: initialValuesOrFunction };
}
//# sourceMappingURL=useAsyncInitialValues.js.map